<template>
  <donate v-if="showDonate" />
  <feedback-request-bar v-if="showFeedback" />
  <div
    :class="`w-full text-lg font-display bg-${backgroundColor} text-${textColor} text-center ${navbarClasses}`"
    v-if="showNavbar"
    data-aos="fade-down"
  >
    <div
      class="flex flex-col lg:flex-row justify-around mx-auto lg:space-x-2"
      v-if="!collapse"
    >
      <button
        v-for="item in items"
        :key="item.text"
        :class="`lg:mt-2 lg:rounded-t flex-1 hover:bg-background hover:text-palette1  ${item.classes} py-4 px-10 flex justify-${buttonJustify} items-center transition duration-300`"
        @click="onClick(item)"
      >
        <p>{{ item.text }}</p>
        <div v-if="isSyncing && item.text == 'practice'" class="mx-4">
          <Sync class="mx-8" />
        </div>
        <div
          class="w-6 h-6 rounded-full bg-background text-palette2 ml-2 flex items-center text-center"
          v-else-if="item.notifications"
        >
          <p class="text-xs mx-auto">{{ item.notifications }}</p>
        </div>
      </button>
      <div class="flex justify-center items-center px-6"></div>
    </div>
    <div v-else>
      <button
        class="flex-1 hover:bg-background hover:text-palette1 py-4 px-8 flex justify-start w-full"
        @click="collapseToggle = false"
      >
        <div>
          <font-awesome-icon icon="bars" />
        </div>
      </button>
    </div>
  </div>
</template>
<script>
import { isDue } from "../practice";
import { warmUp, sync } from "../server";
import Sync from "./Sync";

import { useRoute } from "vue-router";
import FeedbackRequestBar from "./FeedbackRequestBar.vue";
import Donate from "./Donate.vue";

export default {
  components: { FeedbackRequestBar, Donate, Sync },
  data() {
    return {
      //is collapsed
      collapseToggle: true,
    };
  },
  mounted() {
    //warm up heroku server
    warmUp();

    let canSync = this.$store.getters.hasActiveSession;
    console.log("can sync: " + canSync);
    //only sync user if user is logged in
    if (canSync) {
      this.syncAccount();
    }
  },
  methods: {
    async syncAccount() {
      console.log("syncing the account...");
      let sessionId = this.$store.state.sessionId;
      let response = await sync(sessionId);

      this.$store.commit("onSync", response);
    },
    logout() {
      this.$store.commit("logout");
      this.$router.push("/login");
    },
    onClick(item) {
      warmUp();
      this.$router.push(item.url);
      this.collapseToggle = true;
    },
  },
  computed: {
    navbarClasses() {
      if (this.isHome && this.isLoggedIn) return "shadow";
      return "";
    },
    backgroundColor() {
      if (this.isHome) return "background";
      return "palette2";
    },
    textColor() {
      if (this.isHome) return "palette5";
      return "white";
    },
    buttonJustify() {
      if (this.isLoggedIn) return "center";
      return "end";
    },
    showNavbar() {
      if (this.isLoginPage) return false;
      return true;
    },
    currentPath() {
      const route = useRoute();
      return route.path;
    },
    showFeedback() {
      return false;
      /*
      if(this.isHome) return false;
      if (this.isMobile) return false;
      if(this.isLoginPage) return false;
      return !this.isAddPage*/
    },
    showDonate() {
      return false; /*
      if (this.isMobile) return false;
      return this.isAddPage*/
    },
    isLoginPage() {
      return this.currentPath == "/login";
    },
    isHome() {
      return this.currentPath == "/";
    },
    isAddPage() {
      return this.currentPath == "/add";
    },
    isMobile() {
      return this.$isMobile();
    },
    collapse() {
      if (this.isHome && !this.isLoggedIn) return false;
      if (this.isMobile) return this.collapseToggle;
      return false;
    },
    cardsLeftCount() {
      return this.cardsLeft.length;
    },
    cardsLeft() {
      return this.cards.filter((x) => isDue(x));
    },
    cards() {
      return this.$store.state.user.cards;
    },
    email() {
      return this.$store.state?.user?.email;
    },
    isSyncing() {
      return this.$store.state.isSyncing;
    },
    isLoggedIn() {
      return this.$store.state?.user?.ID;
    },
    items() {
      console.log("email:" + email);
      let email = this.email;
      if (this.isLoggedIn) {
        let result = [
          {
            text: "home",
            url: "/",
          },
          {
            text: "practice",
            url: "/practice",
            notifications: this.cardsLeftCount,
          },
          {
            text: "add new word",
            url: "/add",
          },
          {
            text: "my vocabulary",
            url: "/deck",
          },
          {
            text: "progress",
            url: "/stats",
          },
          { text: "logout", url: "/logout" },
        ];
        result.forEach((x) => {
          let isActive = x.url == this.currentPath;
          if (isActive) {
            x.classes = "bg-white text-palette1";
          }
        });
        return result;
      }

      return [
        {
          text: "sign in",
          url: "/login",
        },
      ];
    },
  },
};
</script>
